"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.include3ColumnRecordGate = include3ColumnRecordGate;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

function include3ColumnRecordGate(properties, optedInAndUngated) {
  var event = properties.event,
      objectType = properties.objectType,
      eventProps = properties.eventProps;

  if (optedInAndUngated) {
    return {
      event: event,
      objectType: objectType,
      eventProps: (0, _extends2.default)({
        gate: 'CRM:RecordCanary'
      }, eventProps)
    };
  }

  return properties;
}